import { render, staticRenderFns } from "./DialogBaseForm.vue?vue&type=template&id=0bc0af3e&"
import script from "./DialogBaseForm.vue?vue&type=script&lang=js&"
export * from "./DialogBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports